export default __webpack_public_path__ + "static/Functional_Overview-e1fa8ed35417698420183aee7ef05706.png";